module.exports = __webpack_public_path__ + "img/apple_categories.cf9fe140.png";